<template>
  <div class="modal-mask" @click="close" v-show="show">
    <div class="modal-container" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/components/eventbus/EventBus'
import {
  disableBodyScrollKeepPosition,
  enableBodyScrollKeepPosition
} from '@/common/util/ui.utils'
export default {
  props: [
    'show'
  ],
  methods: {
    close () {
      this.$emit('close')
    }
  },
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  },
  created () {
    EventBus.$once('close', () => {
      this.close()
    })
  },
  watch: {
    show (isShow) {
      if (isShow) {
        disableBodyScrollKeepPosition()
      } else {
        enableBodyScrollKeepPosition()
      }
    }
  }
}
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    -webkit-transition: opacity .3s ease;
    transition: opacity .3s ease;
    overflow-y: scroll;
  }
  .modal-container {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
  }
</style>
